export default __webpack_public_path__ + "static/media/LASKO_A5_1.03fd2630.png";